<script setup lang="ts">
defineProps({ blok: Object });

const localePath = useLocalePath();
</script>

<template>
  <section class="bg-[#FFC14A] overflow-hidden max-[641px]:py-20">
    <UiContainer>
      <div class="grid grid-cols-2 gap-12 items-center max-[641px]:grid-cols-1">
        <header>
          <div
            class="[&>h2]:mb-4 [&>h2]:font-londrina-solid [&>h2]:text-chsc-indigo-500 [&>h2]:fs-6xl [&>p]:font-eb-garamond [&>p]:fs-2xl"
          >
            <StoryblokRichText :doc="blok?.header" />
          </div>
          <div class="mt-8">
            <UButton :to="localePath('/methodology')" :label="blok?.cta" size="xl" />
          </div>
        </header>
        <div class="max-[641px]:hidden">
          <img
            v-motion-slide-visible-once-right
            :src="blok?.image?.filename"
            :alt="blok?.image?.alt"
            class="max-w-none"
          />
        </div>
      </div>
    </UiContainer>
  </section>
</template>
